import classNames from 'classnames';

import type DescriptionDetails from '@/components/ui/lists/descriptionList/DescriptionDetails';
import type DescriptionTerm from '@/components/ui/lists/descriptionList/DescriptionTerm';

import styles from './DescriptionListItem.module.scss';

interface Props {
  children: [
    React.ReactElement<
      React.ComponentProps<typeof DescriptionTerm>,
      typeof DescriptionTerm
    >,
    React.ReactElement<
      React.ComponentProps<typeof DescriptionDetails>,
      typeof DescriptionDetails
    >,
  ];
  className?: string;
}

const DescriptionListItem: React.FC<Props> = ({ children, className }) => (
  <li className={classNames(styles.listItem, className)}>{children}</li>
);

export default DescriptionListItem;
